import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let SignatureDesign = class SignatureDesign extends Vue {
    // @Prop({default:{}})
    // opts!:any
    render(h) {
        return h('a-textarea', { props: {
                disabled: true,
                placeholder: "请输入"
            } });
    }
};
SignatureDesign = tslib_1.__decorate([
    Component({ name: 'SignatureDesign' })
], SignatureDesign);
export default SignatureDesign;
